
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/Hooks/useStreamController.html",
      function () {
        return require("private-next-pages/Hooks/useStreamController.html.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/Hooks/useStreamController.html"])
      });
    }
  